export type NotesReturnOrigin = 'evaluation' | 'classe';

export interface NotesReturnPathParams {
  ecoleId: string;
  anneeScolaireId: string;
  classeId?: string | null;
  returnTo?: NotesReturnOrigin;
}

export const getNotesReturnPath = ({ ecoleId, anneeScolaireId, classeId, returnTo = 'evaluation' }: NotesReturnPathParams) => {
  if (returnTo === 'classe' && classeId) {
    return `/calendar/${ecoleId}/${anneeScolaireId}/${classeId}/calendarEntry?tab=2`;
  }

  return `/evaluation/${ecoleId}/${anneeScolaireId}`;
};
